<div class="row" *ngIf="taxStrategy">
  <div class="small-12 medium-12 columns">
    <div class="row">
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Strategy Name</label>
        <div class="strategy-view-content">
          {{taxStrategy.name}}
        </div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Category</label>
        <div class="strategy-view-content">
          {{taxStrategy.type}}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Federal Associated Rate</label>
        <div class="strategy-view-content">{{taxStrategy.associatedField}}</div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">State Associated Rate</label>
        <div class="strategy-view-content">{{ taxStrategy.stateAssociatedField}}</div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Applicable To</label>
        <div class="strategy-view-content">{{taxStrategy.applicableTo == 'Both'? 'Business & Individual': taxStrategy.applicableTo}}</div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Last Updated</label>
        <div class="strategy-view-content">{{taxStrategy.lastUpdated || ''}}</div>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Eligibility Criteria</label>
        <div class="strategy-view-content" *ngIf="taxStrategy.criteria?.length > 0; else noEligibilityCriteria">
          <ul style="margin: 0 0 0 18px; padding: 0;">
            <li *ngFor="let criteria of taxStrategy.criteria">{{criteria.text}}</li>
          </ul>
        </div>
        <ng-template #noEligibilityCriteria>
          <div class="strategy-view-content">—</div>
        </ng-template>
      </div>
    </div>

    <div class="row">
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Recurring</label>
        <div class="strategy-view-content">{{taxStrategy.recurring == 'Yearly'? "Yes": "No"}}</div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Deadline</label>
        <div class="strategy-view-content">{{taxStrategy.deadline}}</div>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Deadline Description</label>
        <div class="strategy-view-content">
          <app-tpiq-froala-view [data]="taxStrategy.deadlineDescription"></app-tpiq-froala-view>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Complexity
          <span *ngIf="showInfoTooltips" class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
            <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
            <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 180px !important; line-height: 1.35;">
              <strong>Complexity (projected tax-savings calculation)</strong><br />
              1 Single Input: One primary field determines the result<br />
              2 Multiple Inputs: Several fields combine into one result<br />
              3 Conditional: Rules, limits, or comparisons change the result<br />
              4 Complex: Multiple linked calculations, years, or outcomes<br />
              5 Specialized: Requires a strategy-specific calculation<br />
            </span>
          </span>
        </label>
        <div class="strategy-view-content">{{ displayComplexity(taxStrategy.complexity) }}</div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Urgency
          <span *ngIf="showInfoTooltips" class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
            <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
            <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 200px !important; line-height: 1.35;">
              <strong>Urgency (the strategy's deadline)</strong><br />
              1 No deadline<br />
              2 Annual (by 12/31)<br />
              3 Quarterly (estimates/elections)<br />
              4 Weeks (deal closing / election window)<br />
              5 Days (emergency window)<br />
            </span>
          </span>
        </label>
        <div class="strategy-view-content">{{ displayUrgency(taxStrategy.urgency) }}</div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Risk Level
          <span *ngIf="showInfoTooltips" class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
            <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
            <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 320px !important; line-height: 1.35;">
              <strong>Risk (relative uncertainty and scrutiny)</strong><br />
              1 Minimal: Clearly established in tax law<br />
              2 Low: Well established and widely accepted<br />
              3 Moderate: Established planning with some judgment involved<br />
              4 Heightened: Less guidance or case law; may face greater scrutiny<br />
              5 Significant: May require additional IRS disclosure<br />
            </span>
          </span>
        </label>
        <div class="strategy-view-content">{{ displayRisk(taxStrategy.riskLevel) }}</div>
      </div>
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Burden
          <span *ngIf="showInfoTooltips" class="badge-tooltip" style="margin-left: 6px; cursor: pointer; display: inline-flex; align-items: center;">
            <i class="icon ion-ios-information-outline info-icon" style="font-size: 16px; color: #475467;"></i>
            <span class='bottomTooltiptext tpActionTooltip' style="font-size: 12px !important; width: 200px !important; line-height: 1.35;">
              <strong>Burden (on the advisor's firm)</strong><br />
              1 Mostly the client<br />
              2 Client with advisor help<br />
              3 Half client/advisor<br />
              4 Mostly tax advisor<br />
              5 Concierge<br />
            </span>
          </span>
        </label>
        <div class="strategy-view-content">{{ displayBurden(taxStrategy.burden) }}</div>
      </div>
    </div>

    <div class="row">
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Amount Type</label>
        <div class="strategy-view-content">
          {{ taxStrategy.amountType || 'None' }}
        </div>
      </div>
    </div>

    <!--Investment in overview-->

    <div class="row">
      <div class="small-6 medium-5 columns">
        <label class="strategy-view-label">Strategy Requires Investment? </label>
        <div class="strategy-view-content">
          {{ taxStrategy.investmentEnabled }}
        </div>
      </div>
    
      <div class="small-6 medium-5 columns" *ngIf="taxStrategy.investmentEnabled">
        <label class="strategy-view-label">Strategy Investment Formula </label>
        <div class="strategy-view-content">
          {{ taxStrategy.investmentFormula || '0' }}
        </div>
      </div>
    </div>

    <div class="row" *ngIf="taxStrategy.investmentEnabled">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Investment Description</label>
        <div class="strategy-view-content">
          <app-tpiq-froala-view [data]="taxStrategy.investmentDescription || '—'"></app-tpiq-froala-view>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Tags</label>
        <ul class="float-left strategy-view-content" style="margin-left: 30px;">
          <li *ngFor="let tag of taxStrategy.tags">{{tag.label}}</li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Client Overview</label>
        <span class="update-tax-strategy">
          <div class="strategy-info strategy-view-content">
            <app-tpiq-froala-view [data]="taxStrategy.clientOverview"></app-tpiq-froala-view>
          </div>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Client Resources</label>
        <div class="strategy-view-content">
          <app-tpiq-froala-view [data]="taxStrategy.clientResources"></app-tpiq-froala-view>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="small-12 medium-12 columns">
        <label class="strategy-view-label">Client Resources Files</label>
      </div>
      <div class="small-12 medium-12 columns strategy-view-content" *ngIf="taxStrategy.clientResourceFiles.length == 0">
        No files available.
      </div>
      <div class="small-12 medium-12 columns" *ngIf="taxStrategy.clientResourceFiles.length > 0">
        <div class="row">
          <div class="medium-6 columns" *ngFor="let file of taxStrategy.clientResourceFiles; let i=index;">
            <div class="row tp-file-item-box">
              <div class="medium-8 pointer" title="{{file.name}}">
                <div class="tp-file-item-name">{{file.name}}</div>
              </div>
              <div class="column medium-4 post-icons">
                <i class="icon ion-ios-cloud-download-outline float-right post-icons-pad" (click)="getFileData(file)"></i>
              </div>
              <div class="small-12 medium-12 columns" *ngIf="file.fileType == 'image'">
                <div class="row" style="padding: 0px;margin-left: 0px">
                  <img class="image-zoom" [src]="file.temporaryURL"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

